<template>
    <!-- <div id="footer">
        <hr class="footer-line"/>

        <div class="row justify-content-between align-items-start">
            <div class="col col-12 col-md-5 text-left text mb-5 mb-md-0">
                <Logo />
                <p>
                    {{ $t("footer.text") }}
                </p>
            </div>

            <div class="col text-left links">
                <div class="row justify-content-between justify-content-md-end">
                    <div class="col col-12 col-xs-auto text-left">
                        <h4 class="mb-0">{{ $t("footer.check.label") }}</h4>
                        <ul class="mr-0 mr-md-4 d-flex flex-row flex-xs-column">
                            <li><a :href="`${baseUrl}#customers`">{{ $t("footer.check.customers") }}</a></li>
                            <li><a :href="`${baseUrl}#pricing`">{{ $t("footer.check.pricelist") }}</a></li>
                            <li><a :href="conditionsUrl" target="_blank">{{ $t("footer.check.conditions") }}</a></li>
                        </ul>
                    </div>
                    <div class="col col-12 col-xs-auto text-left text-xs-center text-md-left">
                        <h4 class="mb-0 mt-4 mt-xs-0">{{ $t("footer.datlab.label") }}</h4>
                        <ul class="mr-0 mr-md-4 d-flex flex-row flex-xs-column">
                            <li><a href="https://www.datlab.eu/cs/" target="_blank">{{ $t("footer.datlab.web") }}</a></li>
                            <li><a href="https://blog.datlab.eu" target="_blank">{{ $t("footer.datlab.blog") }}</a></li>
                            <li><a href="https://tenderman.cz" target="_blank">{{ $t("footer.datlab.tenderman") }}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col text-left copyright">
                <small class="text-muted">© 2020 Datlab s.r.o. </small>
            </div>
        </div>
    </div> -->

    <div>
        <div class="container-fluid" id="footer">
            <div class="line-logo">
                <img :src="`${publicPath}datlab_logo.svg`">
            </div>

            <div class="row">
                <div class="col">
                    <div class="redflags-logo">
                        <img :src="`${publicPath}footer_d.svg`">
                        <span>K</span>
                    </div>
                </div>
            </div>

            <div class="row justify-content-between">
                <div class="col col-12 col-lg-4 claim">
                    <p>{{ $t("footer.text.0") }}</p>
                    <p>{{ $t("footer.text.1") }}</p>
                </div>

                <div class="col-auto contact">
                    <h4>{{ $t("footer.contact.label") }}</h4>
                    <p class="address" v-html="$t('footer.contact.addressHtml')"></p>
                    <div class="mb-0 vat_id">
                        <div>{{ $t("footer.contact.vatId") }}</div>
                    </div>
                </div>

                <div class="col-auto links">
                    <h4>{{ $t("footer.products.label") }}</h4>
                    <a href="https://tendry.cz/" target="_blank">{{ $t("footer.products.tendry") }}</a>
                    <a href="https://kontrola.datlab.eu/" target="_blank">{{ $t("footer.products.check") }}</a>
                    <a href="https://www.zindex.cz/" target="_blank">{{ $t("footer.products.zindex") }}</a>
                </div>

                <div class="col-auto others">
                    <h4>{{ $t("footer.others.label") }}</h4>
                    <a href="https://www.facebook.com/datlab.cz" target="_blank">{{ $t("footer.others.facebook") }}</a>
                    <a href="https://datlab.cz" target="_blank">{{ $t("footer.others.datlab") }}</a>
                    <a href="https://datlabinstitut.cz" target="_blank">{{ $t("footer.others.institut") }}</a>
                </div>
            </div>
        </div>

        <div class="container-fluid" id="mandatory-info">
            <div class="d-flex justify-content-between">
                <div>
                    {{ $t("footer.copyright") }}
                </div>
                <div class="w-auto ml-3">kontakt@datlab.eu</div>
            </div>
        </div>
    </div>
</template>

<script>
import { CONFIG } from '@/config.js'

export default {
    components: {
    },
    computed: {
        conditionsUrl: function() {
            return "https://docs.google.com/document/d/1_GzWw6DJwsQN9a3OIJvgokQ2JgVlQCcauha76Yn4RJk/edit"
        },
        baseUrl: function() {
            return CONFIG.apiBaseUrl
        },
        publicPath: function() {
            return import.meta.env.BASE_URL
        }
    }

}
</script>

<style lang="scss">
@import "src/scss/_custom";

#footer{
    border-top: 5px double $dark;
    padding-top: 64px;
    padding-bottom: 64px;
    position: relative;
    text-align: left;
    font-size: 16px;
    margin-top: 50px;

    .line-logo {
        position: absolute;
        width: 100%;
        text-align: center;
        line-height: 0;
        top: -10px;
        left: 0;

        img {
            background-color: $body-bg;
        }
    }

    .redflags-logo {
        margin-bottom: 24px;
        font-size: 95px;
        height: 70px;
        line-height: 1;
        display: flex;
        align-items: center;

        img {
            margin-right: 8px;
        }
    }

    .claim {
        font-size: 11px;
        margin-bottom: 50px;
        line-height: 1.64;
    }

    h4 {
        font-weight: 600;
        margin-bottom: 18px;
        font-size: 16px;
        color: $body-color;
    }

    .contact,
    .links,
    .others {
        margin-bottom: 50px;
    }

    .address {
        line-height: 1.63;
    }

    .links,
    .others {
        a {
            display: block;
            color: $body-color;
            font-weight: 500;
            margin-bottom: 16px;

            &:last-of-type {
                margin-bottom: 0;
            }
        }
    }

    .vat_id {
        font-size: 12px;
    }
}

#mandatory-info {
    font-size: 11px;
    border-top: double 3px lighten($dark, 60%);

    & > div {
        padding-top: 18px;
        padding-bottom: 18px;
        opacity: 0.5;
        display: inline-block;
    }
}
</style>